const getters = {
    tagsView: state => state.tagsView.tagsView,
    authModules: state => state.user.authModules,
    isCollapse: state => state.settings.isCollapse,
    uniqueOpen: state => state.settings.uniqueOpen
}

export default getters